export var OptimizerFrequency;
(function (OptimizerFrequency) {
    OptimizerFrequency["Daily"] = "daily";
    OptimizerFrequency["Monthly"] = "monthly";
    OptimizerFrequency["Quarterly"] = "quarterly";
    OptimizerFrequency["Annually"] = "annually";
})(OptimizerFrequency || (OptimizerFrequency = {}));
export var OptimizerStrategy;
(function (OptimizerStrategy) {
    OptimizerStrategy["MaximizeSharpeRatio"] = "max_sharpe";
    OptimizerStrategy["MinimizeStandardDeviation"] = "min_risk";
    OptimizerStrategy["TargetReturn"] = "target_return";
    OptimizerStrategy["TargetStandardDeviation"] = "target_risk";
})(OptimizerStrategy || (OptimizerStrategy = {}));
export var OptimizerErrorCode;
(function (OptimizerErrorCode) {
    OptimizerErrorCode["EndDateAfterOriginEndDate"] = "end_date_after_origin_end_date";
    OptimizerErrorCode["InsufficientPeriods"] = "insufficient_periods";
    OptimizerErrorCode["InvalidWeightBounds"] = "invalid_weight_bounds";
    OptimizerErrorCode["InvalidWeightings"] = "invalid_weightings";
    OptimizerErrorCode["MaxHoldingsExceeded"] = "max_holdings_exceeded";
    OptimizerErrorCode["MissingLevels"] = "missing_levels";
    OptimizerErrorCode["MissingHoldingsData"] = "missing_holdings_data";
    OptimizerErrorCode["NegativeWeightings"] = "negative_weightings";
    OptimizerErrorCode["NoAccessToOriginPortfolio"] = "no_access_to_origin_portfolio";
    OptimizerErrorCode["NoAccessToSpecifiedSecurity"] = "no_access_to_specified_security";
    OptimizerErrorCode["NoData"] = "no_data";
    OptimizerErrorCode["OriginPortfolioDoesNotExist"] = "origin_portfolio_does_not_exist";
    OptimizerErrorCode["OriginPortfolioDynamic"] = "origin_portfolio_dynamic";
    OptimizerErrorCode["OriginPortfolioMarkedForDeletion"] = "origin_portfolio_marked_for_deletion";
    OptimizerErrorCode["CompositeModelPortfolio"] = "composite_model_portfolio";
    OptimizerErrorCode["OriginPortfolioNotAvailable"] = "origin_portfolio_not_available";
    OptimizerErrorCode["StartDateAfterEndDate"] = "start_date_after_end_date";
    OptimizerErrorCode["StartDateBeforeOriginStartDate"] = "start_date_before_origin_start_date";
    OptimizerErrorCode["ZeroRiskHolding"] = "zero_risk_holding";
    OptimizerErrorCode["ReturnsSparseForFreq"] = "returns_sparse_for_freq";
    OptimizerErrorCode["TargetReturnTooHigh"] = "target_return_too_high";
    OptimizerErrorCode["TargetDeviationTooLow"] = "target_deviation_too_low";
    OptimizerErrorCode["Unknown"] = "unknown";
})(OptimizerErrorCode || (OptimizerErrorCode = {}));
/**
 * Values by which portfolio optimizer items can be sorted in the ycn-folderable-open-saved-modal
 */
export var PortfolioOptimizerSortColumn;
(function (PortfolioOptimizerSortColumn) {
    PortfolioOptimizerSortColumn["NAME"] = "name";
    PortfolioOptimizerSortColumn["OWNER"] = "owner";
    PortfolioOptimizerSortColumn["USER_MODIFY_DATE"] = "modify_date";
})(PortfolioOptimizerSortColumn || (PortfolioOptimizerSortColumn = {}));
export var PortfolioOptimizerDropdownOption;
(function (PortfolioOptimizerDropdownOption) {
    PortfolioOptimizerDropdownOption["SHARE"] = "share";
    PortfolioOptimizerDropdownOption["RENAME"] = "rename";
    PortfolioOptimizerDropdownOption["MOVE"] = "move";
    PortfolioOptimizerDropdownOption["DELETE"] = "delete";
})(PortfolioOptimizerDropdownOption || (PortfolioOptimizerDropdownOption = {}));
